// src/components/auth/LoginModal.js - Versión actualizada con email
import React, { useState, useRef, useEffect } from 'react';
import { X, ChevronDown, Search } from 'lucide-react';

// Lista completa de países con código telefónico
const DIAL_CODES = [
  { iso: 'AR', name: 'Argentina',              code: '+54'  },
  { iso: 'ES', name: 'España',                 code: '+34'  },
  { iso: 'AF', name: 'Afganistán',             code: '+93'  },
  { iso: 'AL', name: 'Albania',                code: '+355' },
  { iso: 'DE', name: 'Alemania',               code: '+49'  },
  { iso: 'AD', name: 'Andorra',                code: '+376' },
  { iso: 'AO', name: 'Angola',                 code: '+244' },
  { iso: 'AG', name: 'Antigua y Barbuda',      code: '+1'   },
  { iso: 'SA', name: 'Arabia Saudita',         code: '+966' },
  { iso: 'DZ', name: 'Argelia',                code: '+213' },
  { iso: 'AM', name: 'Armenia',                code: '+374' },
  { iso: 'AU', name: 'Australia',              code: '+61'  },
  { iso: 'AT', name: 'Austria',                code: '+43'  },
  { iso: 'AZ', name: 'Azerbaiyán',             code: '+994' },
  { iso: 'BS', name: 'Bahamas',                code: '+1'   },
  { iso: 'BH', name: 'Baréin',                 code: '+973' },
  { iso: 'BD', name: 'Bangladés',              code: '+880' },
  { iso: 'BB', name: 'Barbados',               code: '+1'   },
  { iso: 'BE', name: 'Bélgica',                code: '+32'  },
  { iso: 'BZ', name: 'Belice',                 code: '+501' },
  { iso: 'BJ', name: 'Benín',                  code: '+229' },
  { iso: 'BY', name: 'Bielorrusia',            code: '+375' },
  { iso: 'BO', name: 'Bolivia',                code: '+591' },
  { iso: 'BA', name: 'Bosnia y Herzegovina',   code: '+387' },
  { iso: 'BW', name: 'Botsuana',               code: '+267' },
  { iso: 'BR', name: 'Brasil',                 code: '+55'  },
  { iso: 'BN', name: 'Brunéi',                 code: '+673' },
  { iso: 'BG', name: 'Bulgaria',               code: '+359' },
  { iso: 'BF', name: 'Burkina Faso',           code: '+226' },
  { iso: 'BI', name: 'Burundi',                code: '+257' },
  { iso: 'BT', name: 'Bután',                  code: '+975' },
  { iso: 'CV', name: 'Cabo Verde',             code: '+238' },
  { iso: 'KH', name: 'Camboya',                code: '+855' },
  { iso: 'CM', name: 'Camerún',                code: '+237' },
  { iso: 'CA', name: 'Canadá',                 code: '+1'   },
  { iso: 'QA', name: 'Catar',                  code: '+974' },
  { iso: 'TD', name: 'Chad',                   code: '+235' },
  { iso: 'CL', name: 'Chile',                  code: '+56'  },
  { iso: 'CN', name: 'China',                  code: '+86'  },
  { iso: 'CY', name: 'Chipre',                 code: '+357' },
  { iso: 'VA', name: 'Ciudad del Vaticano',    code: '+39'  },
  { iso: 'CO', name: 'Colombia',               code: '+57'  },
  { iso: 'KM', name: 'Comoras',                code: '+269' },
  { iso: 'CG', name: 'Congo',                  code: '+242' },
  { iso: 'CD', name: 'Congo (RD)',             code: '+243' },
  { iso: 'KP', name: 'Corea del Norte',        code: '+850' },
  { iso: 'KR', name: 'Corea del Sur',          code: '+82'  },
  { iso: 'CI', name: 'Costa de Marfil',        code: '+225' },
  { iso: 'CR', name: 'Costa Rica',             code: '+506' },
  { iso: 'HR', name: 'Croacia',                code: '+385' },
  { iso: 'CU', name: 'Cuba',                   code: '+53'  },
  { iso: 'DK', name: 'Dinamarca',              code: '+45'  },
  { iso: 'DJ', name: 'Yibuti',                 code: '+253' },
  { iso: 'DM', name: 'Dominica',               code: '+1'   },
  { iso: 'EC', name: 'Ecuador',                code: '+593' },
  { iso: 'EG', name: 'Egipto',                 code: '+20'  },
  { iso: 'SV', name: 'El Salvador',            code: '+503' },
  { iso: 'AE', name: 'Emiratos Árabes',        code: '+971' },
  { iso: 'ER', name: 'Eritrea',                code: '+291' },
  { iso: 'SK', name: 'Eslovaquia',             code: '+421' },
  { iso: 'SI', name: 'Eslovenia',              code: '+386' },
  { iso: 'US', name: 'Estados Unidos',         code: '+1'   },
  { iso: 'EE', name: 'Estonia',                code: '+372' },
  { iso: 'ET', name: 'Etiopía',                code: '+251' },
  { iso: 'PH', name: 'Filipinas',              code: '+63'  },
  { iso: 'FI', name: 'Finlandia',              code: '+358' },
  { iso: 'FJ', name: 'Fiyi',                   code: '+679' },
  { iso: 'FR', name: 'Francia',                code: '+33'  },
  { iso: 'GA', name: 'Gabón',                  code: '+241' },
  { iso: 'GM', name: 'Gambia',                 code: '+220' },
  { iso: 'GE', name: 'Georgia',                code: '+995' },
  { iso: 'GH', name: 'Ghana',                  code: '+233' },
  { iso: 'GD', name: 'Granada',                code: '+1'   },
  { iso: 'GR', name: 'Grecia',                 code: '+30'  },
  { iso: 'GT', name: 'Guatemala',              code: '+502' },
  { iso: 'GN', name: 'Guinea',                 code: '+224' },
  { iso: 'GW', name: 'Guinea-Bisáu',           code: '+245' },
  { iso: 'GQ', name: 'Guinea Ecuatorial',      code: '+240' },
  { iso: 'GY', name: 'Guyana',                 code: '+592' },
  { iso: 'HT', name: 'Haití',                  code: '+509' },
  { iso: 'HN', name: 'Honduras',               code: '+504' },
  { iso: 'HU', name: 'Hungría',                code: '+36'  },
  { iso: 'IN', name: 'India',                  code: '+91'  },
  { iso: 'ID', name: 'Indonesia',              code: '+62'  },
  { iso: 'IQ', name: 'Iraq',                   code: '+964' },
  { iso: 'IR', name: 'Irán',                   code: '+98'  },
  { iso: 'IE', name: 'Irlanda',                code: '+353' },
  { iso: 'IS', name: 'Islandia',               code: '+354' },
  { iso: 'IL', name: 'Israel',                 code: '+972' },
  { iso: 'IT', name: 'Italia',                 code: '+39'  },
  { iso: 'JM', name: 'Jamaica',                code: '+1'   },
  { iso: 'JP', name: 'Japón',                  code: '+81'  },
  { iso: 'JO', name: 'Jordania',               code: '+962' },
  { iso: 'KZ', name: 'Kazajistán',             code: '+7'   },
  { iso: 'KE', name: 'Kenia',                  code: '+254' },
  { iso: 'KG', name: 'Kirguistán',             code: '+996' },
  { iso: 'KI', name: 'Kiribati',               code: '+686' },
  { iso: 'KW', name: 'Kuwait',                 code: '+965' },
  { iso: 'LA', name: 'Laos',                   code: '+856' },
  { iso: 'LS', name: 'Lesoto',                 code: '+266' },
  { iso: 'LV', name: 'Letonia',                code: '+371' },
  { iso: 'LB', name: 'Líbano',                 code: '+961' },
  { iso: 'LR', name: 'Liberia',                code: '+231' },
  { iso: 'LY', name: 'Libia',                  code: '+218' },
  { iso: 'LI', name: 'Liechtenstein',          code: '+423' },
  { iso: 'LT', name: 'Lituania',               code: '+370' },
  { iso: 'LU', name: 'Luxemburgo',             code: '+352' },
  { iso: 'MK', name: 'Macedonia del Norte',    code: '+389' },
  { iso: 'MG', name: 'Madagascar',             code: '+261' },
  { iso: 'MY', name: 'Malasia',                code: '+60'  },
  { iso: 'MW', name: 'Malaui',                 code: '+265' },
  { iso: 'MV', name: 'Maldivas',               code: '+960' },
  { iso: 'ML', name: 'Mali',                   code: '+223' },
  { iso: 'MT', name: 'Malta',                  code: '+356' },
  { iso: 'MA', name: 'Marruecos',              code: '+212' },
  { iso: 'MH', name: 'Islas Marshall',         code: '+692' },
  { iso: 'MR', name: 'Mauritania',             code: '+222' },
  { iso: 'MU', name: 'Mauricio',               code: '+230' },
  { iso: 'MX', name: 'México',                 code: '+52'  },
  { iso: 'FM', name: 'Micronesia',             code: '+691' },
  { iso: 'MD', name: 'Moldavia',               code: '+373' },
  { iso: 'MC', name: 'Mónaco',                 code: '+377' },
  { iso: 'MN', name: 'Mongolia',               code: '+976' },
  { iso: 'ME', name: 'Montenegro',             code: '+382' },
  { iso: 'MZ', name: 'Mozambique',             code: '+258' },
  { iso: 'MM', name: 'Myanmar',                code: '+95'  },
  { iso: 'NA', name: 'Namibia',                code: '+264' },
  { iso: 'NR', name: 'Nauru',                  code: '+674' },
  { iso: 'NP', name: 'Nepal',                  code: '+977' },
  { iso: 'NI', name: 'Nicaragua',              code: '+505' },
  { iso: 'NE', name: 'Níger',                  code: '+227' },
  { iso: 'NG', name: 'Nigeria',                code: '+234' },
  { iso: 'NO', name: 'Noruega',                code: '+47'  },
  { iso: 'NZ', name: 'Nueva Zelanda',          code: '+64'  },
  { iso: 'OM', name: 'Omán',                   code: '+968' },
  { iso: 'NL', name: 'Países Bajos',           code: '+31'  },
  { iso: 'PK', name: 'Pakistán',               code: '+92'  },
  { iso: 'PW', name: 'Palaos',                 code: '+680' },
  { iso: 'PA', name: 'Panamá',                 code: '+507' },
  { iso: 'PG', name: 'Papúa Nueva Guinea',     code: '+675' },
  { iso: 'PY', name: 'Paraguay',               code: '+595' },
  { iso: 'PE', name: 'Perú',                   code: '+51'  },
  { iso: 'PL', name: 'Polonia',                code: '+48'  },
  { iso: 'PT', name: 'Portugal',               code: '+351' },
  { iso: 'GB', name: 'Reino Unido',            code: '+44'  },
  { iso: 'CF', name: 'República Centroafricana', code: '+236' },
  { iso: 'CZ', name: 'República Checa',        code: '+420' },
  { iso: 'DO', name: 'República Dominicana',   code: '+1'   },
  { iso: 'RW', name: 'Ruanda',                 code: '+250' },
  { iso: 'RO', name: 'Rumania',                code: '+40'  },
  { iso: 'RU', name: 'Rusia',                  code: '+7'   },
  { iso: 'WS', name: 'Samoa',                  code: '+685' },
  { iso: 'KN', name: 'San Cristóbal y Nieves', code: '+1'   },
  { iso: 'SM', name: 'San Marino',             code: '+378' },
  { iso: 'VC', name: 'San Vicente y Granadinas', code: '+1' },
  { iso: 'LC', name: 'Santa Lucía',            code: '+1'   },
  { iso: 'ST', name: 'Santo Tomé y Príncipe',  code: '+239' },
  { iso: 'SN', name: 'Senegal',                code: '+221' },
  { iso: 'RS', name: 'Serbia',                 code: '+381' },
  { iso: 'SC', name: 'Seychelles',             code: '+248' },
  { iso: 'SL', name: 'Sierra Leona',           code: '+232' },
  { iso: 'SG', name: 'Singapur',               code: '+65'  },
  { iso: 'SY', name: 'Siria',                  code: '+963' },
  { iso: 'SO', name: 'Somalia',                code: '+252' },
  { iso: 'LK', name: 'Sri Lanka',              code: '+94'  },
  { iso: 'SZ', name: 'Suazilandia',            code: '+268' },
  { iso: 'ZA', name: 'Sudáfrica',              code: '+27'  },
  { iso: 'SD', name: 'Sudán',                  code: '+249' },
  { iso: 'SS', name: 'Sudán del Sur',          code: '+211' },
  { iso: 'SE', name: 'Suecia',                 code: '+46'  },
  { iso: 'CH', name: 'Suiza',                  code: '+41'  },
  { iso: 'SR', name: 'Surinam',                code: '+597' },
  { iso: 'TH', name: 'Tailandia',              code: '+66'  },
  { iso: 'TZ', name: 'Tanzania',               code: '+255' },
  { iso: 'TJ', name: 'Tayikistán',             code: '+992' },
  { iso: 'TL', name: 'Timor Oriental',         code: '+670' },
  { iso: 'TG', name: 'Togo',                   code: '+228' },
  { iso: 'TO', name: 'Tonga',                  code: '+676' },
  { iso: 'TT', name: 'Trinidad y Tobago',      code: '+1'   },
  { iso: 'TN', name: 'Túnez',                  code: '+216' },
  { iso: 'TM', name: 'Turkmenistán',           code: '+993' },
  { iso: 'TR', name: 'Turquía',                code: '+90'  },
  { iso: 'TV', name: 'Tuvalu',                 code: '+688' },
  { iso: 'UA', name: 'Ucrania',                code: '+380' },
  { iso: 'UG', name: 'Uganda',                 code: '+256' },
  { iso: 'UY', name: 'Uruguay',                code: '+598' },
  { iso: 'UZ', name: 'Uzbekistán',             code: '+998' },
  { iso: 'VU', name: 'Vanuatu',                code: '+678' },
  { iso: 'VE', name: 'Venezuela',              code: '+58'  },
  { iso: 'VN', name: 'Vietnam',                code: '+84'  },
  { iso: 'YE', name: 'Yemen',                  code: '+967' },
  { iso: 'ZM', name: 'Zambia',                 code: '+260' },
  { iso: 'ZW', name: 'Zimbabue',               code: '+263' },
];

const DEFAULT_COUNTRY = DIAL_CODES.find(c => c.iso === 'AR');

const API_BASE_URL     = process.env.REACT_APP_API_BASE_URL     || 'http://localhost:8000';
const TELEGRAM_BOT_USERNAME = process.env.REACT_APP_TELEGRAM_BOT_USERNAME || 'CholloMan_Bot';

export const LoginModal = ({ isOpen, onClose, onLogin, modoInicial = 'login' }) => {
  const [isLoginMode, setIsLoginMode] = useState(modoInicial !== 'registro');
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    full_name: '',
    phone: ''
  });
  const [loading,          setLoading]          = useState(false);
  const [error,            setError]            = useState('');
  const [dialCountry,      setDialCountry]      = useState(DEFAULT_COUNTRY);
  const [phoneLocal,       setPhoneLocal]       = useState('');
  const [phoneSearch,      setPhoneSearch]      = useState('');
  const [showDialDropdown, setShowDialDropdown] = useState(false);
  const [registeredUser,   setRegisteredUser]   = useState(null);  // paso post-registro
  // Flujo de código por correo. Va con el resto de los hooks y no junto a sus
  // funciones, más abajo: los hooks deben ejecutarse siempre y en el mismo
  // orden, y ahí abajo ya hay un `return` condicional que se los saltaría.
  //
  //   null                       → fuera del flujo
  //   { tipo, paso, email, ... }  → tipo: 'recuperacion' | 'ingreso'
  //                                 paso: 'pedir' | 'canjear'
  const [codigo, setCodigo] = useState(null);
  // Paso opcional tras entrar con un código: los datos que la cuenta no tiene.
  const [completar, setCompletar] = useState(null);

  // Va junto al estado que usa y antes de cualquier `return`: declarada con
  // `const` más abajo quedaba en zona muerta, y el JSX que la referencia se
  // evalúa al construir el elemento —o sea, antes—. Habría lanzado
  // «Cannot access before initialization» justo al mostrar la pantalla.
  const guardarPerfil = async (e) => {
    e.preventDefault();
    setCompletar(c => ({ ...c, guardando: true }));
    try {
      const token = localStorage.getItem('token');
      const r = await fetch(`${API_BASE_URL}/users/profile`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          full_name: completar.full_name.trim() || undefined,
          phone: completar.phone.trim() || undefined,
        }),
      });
      if (r.ok) onLogin(await r.json());
    } catch {
      // Si falla, no se insiste: son datos opcionales y la cuenta ya sirve.
    } finally {
      setCompletar(null);
      onClose();
    }
  };

  const dialRef = useRef(null);

  // El componente queda montado aunque esté cerrado, así que el estado inicial
  // no vuelve a evaluarse: hay que sincronizar el modo cada vez que se abre.
  // Sin esto, "Avísame cuando esté lista" mostraría el formulario de acceso.
  useEffect(() => {
    if (isOpen) setIsLoginMode(modoInicial !== 'registro');
  }, [isOpen, modoInicial]);

  // Cerrar dropdown al hacer click fuera
  useEffect(() => {
    const handler = (e) => {
      if (dialRef.current && !dialRef.current.contains(e.target)) {
        setShowDialDropdown(false);
        setPhoneSearch('');
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const endpoint = isLoginMode ? '/login' : '/register';
      // Sin número no se manda nada: `dialCountry.code` solo sería «+54», que
      // el backend rechazaría por no tener los dígitos, y el usuario vería un
      // error sobre un campo que decidió no completar.
      const telefono = phoneLocal.trim() ? dialCountry.code + phoneLocal.trim() : undefined;
      const payload = isLoginMode
        ? { email: formData.email, password: formData.password }
        : { ...formData, phone: telefono };

      // Acá había un `console.log(payload)` que escribía la CONTRASEÑA en claro
      // en la consola del navegador, en producción incluida.

      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        if (isLoginMode) {
          localStorage.setItem('token', data.access_token);
          const userResponse = await fetch(`${API_BASE_URL}/me`, {
            headers: { 'Authorization': `Bearer ${data.access_token}` }
          });
          const userData = await userResponse.json();
          onLogin(userData);
          onClose();
        } else {
          // Después del registro: login automático y mostrar paso Telegram
          const loginResponse = await fetch(`${API_BASE_URL}/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: formData.email, password: formData.password }),
          });
          const loginData = await loginResponse.json();
          if (loginResponse.ok) {
            localStorage.setItem('token', loginData.access_token);
            setRegisteredUser(data);   // muestra el paso de vinculación Telegram (onLogin se llama al cerrar)
          }
        }
      } else {
        setError(data.detail || 'Error en la autenticación');
      }
    } catch (error) {
      console.error('❌ Error en autenticación:', error);
      setError('Error de conexión. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    const pendingUser = registeredUser;
    setFormData({ username: '', email: '', password: '', full_name: '', phone: '' });
    setDialCountry(DEFAULT_COUNTRY);
    setPhoneLocal('');
    setPhoneSearch('');
    setShowDialDropdown(false);
    setError('');
    setLoading(false);
    setRegisteredUser(null);
    setCodigo(null);
    if (pendingUser) {
      onLogin(pendingUser);  // notificar al padre recién cuando el usuario cierra el paso Telegram
    }
    onClose();
  };

  // ── Paso post-registro: vinculación Telegram ──────────────────────────────
  // IMPORTANTE: este check debe ir ANTES de `if (!isOpen) return null`
  // porque el padre puede poner isOpen=false al recibir onLogin, y necesitamos
  // mantener este paso visible hasta que el usuario lo cierre.
  if (registeredUser) {
    const telegramLink = `https://t.me/${TELEGRAM_BOT_USERNAME}?start=${registeredUser.id}`;
    return (
      <div id="login-modal-exito" className="modal-overlay dialogo dialogo--acceso">
        <div className="modal-caja dialogo__caja dialogo__caja--acceso dialogo__caja--centrada">
          <div className="emoji-vacio">🎉</div>
          <h2 className="dialogo__titulo">¡Cuenta creada!</h2>
          <p className="dialogo__texto">
            Hola <strong>{registeredUser.username}</strong>, ya podés explorar ofertas.
            <br />
            Conectá tu Telegram para recibir alertas personalizadas cuando encontremos productos o viajes de tu interés.
          </p>

          <div className="aviso aviso--telegram">
            <div className="aviso__emoji">💬</div>
            <p>Al vincular tu Telegram, el bot te enviará collages de ofertas cuando encuentre coincidencias con tus alertas.</p>
          </div>

          <div className="columna columna--gap8">
            <a
              href={telegramLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setTimeout(handleClose, 500)}
              className="boton-dialogo boton-dialogo--telegram"
            >
              Vincular Telegram ahora
            </a>

            <button onClick={handleClose} className="boton-dialogo boton-dialogo--fantasma">
              Más tarde
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ── Paso opcional: completar el perfil ────────────────────────────────────
  //
  // Va ANTES de `if (!isOpen)`, igual que el paso de Telegram, y por el mismo
  // motivo: `onLogin()` hace que el padre ponga isOpen=false en el acto, así que
  // un `return null` por delante se lleva esta pantalla puesta.
  //
  // Estuvo detrás, y el síntoma era desconcertante: al entrar no aparecía nada,
  // y el cuadro saltaba recién al cerrar sesión y volver a abrir el acceso. El
  // estado `completar` seguía vivo —el componente no se desmonta, sólo deja de
  // pintarse— y se mostraba en cuanto `isOpen` volvía a ser true.
  if (completar) {
    return (
      <div id="login-modal-completar" className="modal-overlay dialogo dialogo--acceso">
        <div className="modal-caja dialogo__caja dialogo__caja--acceso">
          <button
            onClick={() => { setCompletar(null); onClose(); }}
            aria-label="Saltar"
            className="dialogo__cerrar"
          >
            <X size={20} />
          </button>

          <div className="dialogo__encabezado">
            <h2 className="dialogo__titulo">¡Ya estás dentro!</h2>
            <p className="dialogo__texto">
              Entraste como <strong>{completar.usuario?.email}</strong>. Si querés,
              completá estos datos para que las alertas te lleguen a tu nombre.
              Podés hacerlo más tarde desde «Mi cuenta».
            </p>
          </div>

          <form id="login-modal-completar-form" onSubmit={guardarPerfil} className="columna columna--gap16">
            <div>
              <label className="campo__etiqueta">
                Nombre <span className="campo__opcional">— opcional</span>
              </label>
              <input
                id="login-modal-completar-nombre"
                type="text"
                autoFocus
                value={completar.full_name}
                onChange={(e) => setCompletar(c => ({ ...c, full_name: e.target.value }))}
                className="campo__control"
                placeholder="Tu nombre"
              />
            </div>

            <div>
              <label className="campo__etiqueta">
                Teléfono <span className="campo__opcional">— opcional</span>
              </label>
              <input
                id="login-modal-completar-telefono"
                type="tel"
                value={completar.phone}
                onChange={(e) => setCompletar(c => ({ ...c, phone: e.target.value }))}
                className="campo__control"
                placeholder="+54 9 11 ..."
              />
            </div>

            <button
              id="login-modal-completar-guardar"
              type="submit"
              disabled={completar.guardando}
              className="boton-dialogo boton-dialogo--principal"
            >
              {completar.guardando ? 'Guardando…' : 'Guardar y empezar'}
            </button>
          </form>

          <div className="dialogo__salidas">
            <button
              id="login-modal-completar-saltar"
              type="button"
              onClick={() => { setCompletar(null); onClose(); }}
              className="enlace-discreto"
            >
              Ahora no, llevame a las ofertas
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!isOpen) return null;

  // ── Recuperar contraseña / entrar con código ──────────────────────────────
  //
  // Los dos flujos son el mismo: se pide un código al correo y se canjea. Lo
  // único que cambia es que `recuperacion` además fija una contraseña nueva.
  //
  // Se resuelve con un estado propio en vez de sumar otro booleano junto a
  // `isLoginMode`: con dos banderas independientes existen combinaciones que no
  // significan nada («modo registro» y «recuperando» a la vez) y hay que
  // acordarse de apagar una al encender la otra.
  const abrirCodigo = (tipo) => {
    setError('');
    setCodigo({
      tipo, paso: 'pedir',
      email: formData.email || '',   // si ya escribió el correo, se aprovecha
      valor: '', password: '', aviso: '',
    });
  };

  const volverALogin = () => { setCodigo(null); setError(''); };


  const pedirCodigo = async (e) => {
    e?.preventDefault();
    setLoading(true);
    setError('');
    try {
      const r = await fetch(`${API_BASE_URL}/auth/codigo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: codigo.email, tipo: codigo.tipo }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { setError(d.detail || 'No se pudo enviar el código.'); return; }
      // El servidor responde lo mismo exista o no la cuenta, para no delatar
      // qué direcciones están registradas. Acá se refleja tal cual.
      setCodigo(c => ({ ...c, paso: 'canjear', aviso: d.mensaje || '' }));
    } catch {
      setError('Error de conexión. Intentá nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  const canjearCodigo = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const r = await fetch(`${API_BASE_URL}/auth/verificar-codigo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: codigo.email,
          codigo: codigo.valor,
          tipo: codigo.tipo,
          ...(codigo.tipo === 'recuperacion' ? { password: codigo.password } : {}),
        }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { setError(d.detail || 'El código no es válido.'); return; }

      // Acertar el código ya demostró el control del correo: se entra directo,
      // sin pedir que inicie sesión otra vez con la contraseña recién puesta.
      localStorage.setItem('token', d.access_token);
      const me = await fetch(`${API_BASE_URL}/me`, {
        headers: { Authorization: `Bearer ${d.access_token}` },
      });
      const usuario = await me.json();
      onLogin(usuario);

      // Con el perfil a medias se ofrece completarlo ahora, que es el único
      // momento en que alguien está dispuesto a dar sus datos: ya entró, la
      // pantalla está abierta y todavía no se fue a mirar ofertas. Es opcional
      // —se puede saltar— porque la cuenta ya funciona sin eso.
      if (d.perfil_incompleto) {
        setCompletar({ usuario, full_name: '', phone: '', guardando: false });
        setCodigo(null);
        return;
      }
      setCodigo(null);
      onClose();
    } catch {
      setError('Error de conexión. Intentá nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  if (isOpen && codigo) {
    const esRecuperar = codigo.tipo === 'recuperacion';
    return (
      <div id="login-modal" className="modal-overlay dialogo dialogo--acceso">
        <div id="login-modal-caja" className="modal-caja dialogo__caja dialogo__caja--acceso">
          <button onClick={handleClose} aria-label="Cerrar" className="dialogo__cerrar">
            <X size={20} />
          </button>

          <div className="dialogo__encabezado">
            <h2 className="dialogo__titulo">
              {esRecuperar ? 'Recuperar contraseña' : 'Entrar sin contraseña'}
            </h2>
            <p className="dialogo__texto">
              {codigo.paso === 'pedir'
                ? (esRecuperar
                    ? 'Te mandamos un código de 6 dígitos por correo.'
                    : 'Escribí tu correo y te mandamos un código de 6 dígitos. Si todavía no tenés cuenta, se crea sola.')
                : `Escribí el código que enviamos a ${codigo.email}.`}
            </p>
          </div>

          {error && (
            <div id="login-modal-codigo-error" className="aviso aviso--error">
              {error}
            </div>
          )}

          {codigo.paso === 'pedir' ? (
            <form id="login-modal-codigo-pedir" onSubmit={pedirCodigo} className="columna columna--gap16">
              <div>
                <label className="campo__etiqueta">Email</label>
                <input
                  id="login-modal-codigo-email"
                  type="email"
                  required
                  autoFocus
                  value={codigo.email}
                  onChange={(e) => setCodigo(c => ({ ...c, email: e.target.value }))}
                  className="campo__control"
                  placeholder="tu@email.com"
                />
              </div>
              <button
                id="login-modal-codigo-enviar"
                type="submit"
                disabled={loading}
                className="boton-dialogo boton-dialogo--principal"
              >
                {loading ? 'Enviando…' : 'Enviarme el código'}
              </button>
            </form>
          ) : (
            <form id="login-modal-codigo-canjear" onSubmit={canjearCodigo} className="columna columna--gap16">
              {codigo.aviso && (
                <p id="login-modal-codigo-aviso" className="aviso aviso--neutro">
                  {codigo.aviso}
                </p>
              )}
              <div>
                <label className="campo__etiqueta">Código</label>
                <input
                  id="login-modal-codigo-valor"
                  type="text"
                  required
                  autoFocus
                  value={codigo.valor}
                  onChange={(e) => setCodigo(c => ({ ...c, valor: e.target.value.replace(/\D/g, '').slice(0, 6) }))}
                  // `inputMode` abre el teclado numérico en el teléfono, y
                  // `one-time-code` deja que el sistema lo ofrezca solo desde la
                  // notificación del correo.
                  inputMode="numeric"
                  autoComplete="one-time-code"
                  maxLength={6}
                  className="campo__control campo__control--codigo"
                  placeholder="000000"
                />
              </div>

              {esRecuperar && (
                <div>
                  <label className="campo__etiqueta">
                    Contraseña nueva
                  </label>
                  <input
                    id="login-modal-codigo-password"
                    type="password"
                    required
                    minLength={6}
                    value={codigo.password}
                    onChange={(e) => setCodigo(c => ({ ...c, password: e.target.value }))}
                    className="campo__control"
                    placeholder="Al menos 6 caracteres"
                  />
                </div>
              )}

              <button
                id="login-modal-codigo-confirmar"
                type="submit"
                disabled={loading || codigo.valor.length !== 6}
                className="boton-dialogo boton-dialogo--principal"
              >
                {loading ? 'Verificando...' : (esRecuperar ? 'Cambiar contraseña y entrar' : 'Entrar')}
              </button>

              <button
                id="login-modal-codigo-reenviar"
                type="button"
                onClick={pedirCodigo}
                disabled={loading}
                className="enlace-discreto"
              >
                No me llegó, enviar otro
              </button>
            </form>
          )}

          <div className="dialogo__pie">
            <button
              id="login-modal-codigo-volver"
              onClick={volverALogin}
              className="enlace-acento"
            >
              Volver a iniciar sesión
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="login-modal" className="modal-overlay dialogo dialogo--acceso">
      <div id="login-modal-caja" className="modal-caja dialogo__caja dialogo__caja--acceso">
        <button onClick={handleClose} aria-label="Cerrar" className="dialogo__cerrar">
          <X size={20} />
        </button>

        <div className="dialogo__encabezado">
          <h2 className="dialogo__titulo">
            {isLoginMode ? 'Iniciar Sesión' : 'Crear Cuenta'}
          </h2>
          <p className="dialogo__texto">
            {isLoginMode ? 'Bienvenido de vuelta!' : '¡Únete a nuestra comunidad!'}
          </p>
        </div>

        {error && (
          <div className="aviso aviso--error">
            {error}
          </div>
        )}

        <form id="login-modal-form" onSubmit={handleSubmit} className="columna columna--gap16">
          {/* Email - SIEMPRE VISIBLE */}
          <div>
            <label className="campo__etiqueta">
              Email
            </label>
            <input
              type="email"
              required
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              className="campo__control"
              placeholder="tu@email.com"
            />
          </div>

          {/* Campos adicionales solo para registro */}
          {!isLoginMode && (
            <>
              <div>
                <label className="campo__etiqueta">
                  Usuario
                </label>
                <input
                  type="text"
                  required
                  value={formData.username}
                  onChange={(e) => setFormData({...formData, username: e.target.value})}
                  className="campo__control"
                  placeholder="Tu nombre de usuario"
                />
              </div>
              <div>
                <label className="campo__etiqueta">
                  Nombre Completo
                </label>
                <input
                  type="text"
                  value={formData.full_name}
                  onChange={(e) => setFormData({...formData, full_name: e.target.value})}
                  className="campo__control"
                  placeholder="Tu nombre completo"
                />
              </div>
              <div>
                <label className="campo__etiqueta">
                  Teléfono <span className="campo__opcional">— opcional</span>
                </label>
                <div className="fila-telefono">

                  {/* Selector de código de país */}
                  <div ref={dialRef} className="relativo no-encoge">
                    <button
                      type="button"
                      onClick={() => { setShowDialDropdown(v => !v); setPhoneSearch(''); }}
                      className="selector-dial"
                    >
                      <span className="selector-dial__codigo">{dialCountry.code}</span>
                      <span className="selector-dial__iso">{dialCountry.iso}</span>
                      <ChevronDown size={13} className="selector-dial__flecha" />
                    </button>

                    {/* Dropdown */}
                    {showDialDropdown && (
                      <div className="prefijos">
                        <div className="prefijos__buscador">
                          <Search size={13} className="icono-apagado" />
                          <input
                            autoFocus
                            type="text"
                            placeholder="Buscar país..."
                            value={phoneSearch}
                            onChange={e => setPhoneSearch(e.target.value)}
                            className="prefijos__input"
                          />
                        </div>

                        <div className="prefijos__lista">
                          {DIAL_CODES
                            .filter(c => {
                              const q = phoneSearch.toLowerCase();
                              return !q || c.name.toLowerCase().includes(q) || c.code.includes(q) || c.iso.toLowerCase().includes(q);
                            })
                            .map(c => (
                              <button
                                key={c.iso}
                                type="button"
                                onClick={() => { setDialCountry(c); setShowDialDropdown(false); setPhoneSearch(''); }}
                                className={`prefijo-opcion${dialCountry.iso === c.iso ? ' prefijo-opcion--activa' : ''}`}
                                aria-current={dialCountry.iso === c.iso ? 'true' : undefined}
                              >
                                <span className="prefijo-opcion__codigo">{c.code}</span>
                                <span className="prefijo-opcion__nombre">{c.name}</span>
                                <span className="prefijo-opcion__iso">{c.iso}</span>
                              </button>
                            ))
                          }
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Número local */}
                  <input
                    type="tel"
                    value={phoneLocal}
                    onChange={e => setPhoneLocal(e.target.value.replace(/[^0-9\s-]/g, ''))}
                    placeholder="Número sin código"
                    className="campo-telefono"
                  />
                </div>
                <p className="campo__ayuda">
                  {phoneLocal
                    ? <>Número completo: <strong>{dialCountry.code}{phoneLocal}</strong></>
                    : 'Sólo hace falta para vincular Telegram y recibir las alertas. Se puede agregar después desde «Mi cuenta».'}
                </p>
              </div>
            </>
          )}

          <div>
            <label className="campo__etiqueta">
              Contraseña
            </label>
            <input
              type="password"
              required
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              className="campo__control"
              placeholder="Tu contraseña"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="boton-dialogo boton-dialogo--principal"
          >
            {loading ? 'Cargando...' : (isLoginMode ? 'Iniciar Sesión' : 'Crear Cuenta')}
          </button>
        </form>

        {/* Salidas para quien no puede entrar con la contraseña. Antes no había
            ninguna: si se olvidaba, la cuenta quedaba inaccesible. */}
        {isLoginMode && (
          <div className="dialogo__salidas">
            <button
              id="login-modal-olvide"
              type="button"
              onClick={() => abrirCodigo('recuperacion')}
              className="enlace-discreto"
            >
              ¿Olvidaste tu contraseña?
            </button>
            <button
              id="login-modal-entrar-codigo"
              type="button"
              onClick={() => abrirCodigo('ingreso')}
              className="enlace-discreto"
            >
              Entrar sin contraseña, con un código por correo
            </button>
          </div>
        )}

        <div className="dialogo__pie">
          <button
            onClick={() => setIsLoginMode(!isLoginMode)}
            className="enlace-acento"
          >
            {isLoginMode ? '¿No tienes cuenta? Regístrate' : '¿Ya tienes cuenta? Inicia sesión'}
          </button>
        </div>
      </div>
    </div>
  );
};